import instagramSvg from 'assets/images/bt_instagram.svg';
import facebookSvg from 'assets/images/bt_facebook.svg';
import linkedinSvg from 'assets/images/bt_linkedin.svg';
import { StyledSocialLinks } from '../styled';

const SocialLinks = ({ links }) => {
  const { instagram, facebook, linkedin, site } = links;
  const normalizeSiteUrl = url => {
    if (!url) return '';
    try {
      return new URL(/^https?:\/\//i.test(url) ? url : `https://${url}`).toString();
    } catch (error) {
      console.error('Invalid URL:', url);
      return '';
    }
  };
  const siteUrl = normalizeSiteUrl(site);
  const formatSiteName = url => {
    if (!url) return '';
    try {
      return new URL(url).hostname;
    } catch (error) {
      return '';
    }
  };

  return (
    <StyledSocialLinks>
      {instagram && (
        <a href={instagram} target="_blank" rel="noopener noreferrer">
          <img src={instagramSvg} alt="instagram" />
        </a>
      )}
      {facebook && (
        <a href={facebook} target="_blank" rel="noopener noreferrer">
          <img src={facebookSvg} alt="facebook" />
        </a>
      )}
      {linkedin && (
        <a href={linkedin} target="_blank" rel="noopener noreferrer">
          <img src={linkedinSvg} alt="linkedin" />
        </a>
      )}
      {siteUrl && (
        <a className="site" href={siteUrl} target="_blank" rel="noopener noreferrer">
          {formatSiteName(siteUrl)}
        </a>
      )}
    </StyledSocialLinks>
  );
};

export default SocialLinks;
